import { Dispatch, useReducer } from "react";

type Actions<State> = { [key: string]: (state: State, ...args: any) => State };
type ReducerActions<
  State,
  T extends Actions<State>,
  K = T[keyof T],
> = K extends (state: State, ...args: infer P) => State ? [K, ...P] : never;

const reducer = (state, action) => {
  const [func, ...args] = action;
  if (!func) return state;
  return func.apply(this, [state, ...args]);
};

export function useActionsReducer<State, A extends Actions<State>>(
  actions: A, //not used but might be handy for inferring types
  initial: State,
) {
  return useReducer(
    reducer as (state: State, action: ReducerActions<State, A>) => State,
    initial,
  );
}

export type ActionsDispatch<State, A extends Actions<State>> = Dispatch<
  ReducerActions<State, A, A[keyof A]>
>;

export type ActionsDispatchUnknown<State> = Dispatch<
  [(state: State, ...rest: unknown[]) => State, ...unknown[]]
>;
